import { createFileRoute } from "@tanstack/react-router";
import { pageHead } from "../utils/page-title";

export const Route = createFileRoute("/library")({
  // The library session is currently browser-storage backed, so SSR would
  // produce a different initial tree for signed-in users.
  ssr: false,
  head: () =>
    pageHead("Your Charts", {
      canonicalPath: "/charts",
      robots: "noindex, nofollow",
    }),
});
